import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import { AppBar, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { ColorDynamic } from "../theme/Color.js";
import { VisibilityObserver } from "../utils/VisibilityObserver.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  appBar: {
    '&&': {
      bottom: 0,
      top: 'auto',
      borderLeft: 'none',
      borderRight: 'none',
      borderBottom: 'none',
      transition: theme.transitions.create(['border-color']),
      '&:not($appBarSticky)': {
        borderTopColor: ColorDynamic.Transparent
      }
    }
  },
  appBarSticky: {},
  toolbar: {
    '&.MuiToolbar-gutters': {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4)
      }
    }
  }
}), {
  name: 'SD-DrawerActions'
});
/** @deprecated Use `<AppDrawer>` instead. */
export var DrawerActions = /*#__PURE__*/forwardRef((_ref, appBarRef) => {
  var {
      children,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles();
  return /*#__PURE__*/_jsx(VisibilityObserver, {
    render: _ref2 => {
      var {
        ref,
        visibility
      } = _ref2;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(AppBar, _objectSpread(_objectSpread({}, props), {}, {
          ref: appBarRef,
          position: "sticky",
          className: clsx(className, styles.appBar, {
            [styles.appBarSticky]: visibility === 'invisible'
          }),
          children: /*#__PURE__*/_jsx(Toolbar, {
            className: styles.toolbar,
            children: children
          })
        })), /*#__PURE__*/_jsx("div", {
          ref: ref
        })]
      });
    }
  });
});
if (process.env.NODE_ENV !== "production") DrawerActions.displayName = "DrawerActions";